export default function getWSClient(wsPath) {
    return new WebSocket(`${process.env.REACT_APP__WS_HOST}/${wsPath}`);
}
